// @flow
import type { Invoice as ApiInvoice } from 'api/invoices';
import type { Action } from '../actions/invoices';

export type Invoice = {
  ...$Exact<ApiInvoice>,
  isFetching: boolean
};

export type State = {
  byId: {
    [string]: {
      ...Invoice,
      isFetching: boolean
    }
  }
};

export default function invoices(state: State = { byId: {} }, action: Action) {
  switch (action.type) {
    case 'FETCH_INVOICE_REQUEST':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.invoiceId]: {
            ...state.byId[action.invoiceId],
            id: action.invoiceId,
            isFetching: true
          }
        }
      };
    case 'FETCH_INVOICE_SUCCESS':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.invoice.id]: {
            ...action.invoice,
            isFetching: false
          }
        }
      };
    default:
      // this causes a flow error if there are any unhandled actions
      (action: empty); // eslint-disable-line no-unused-expressions
      return state;
  }
}
